var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMarkRoundedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6 6A5.6 5.6 0 11.4 6a5.6 5.6 0 0111.2 0zM6 3.9a.7.7 0 00-.607.35.7.7 0 11-1.212-.7A2.1 2.1 0 116.7 6.581V6.7a.7.7 0 11-1.4 0V6a.7.7 0 01.7-.7.7.7 0 100-1.4zm0 5.6a.7.7 0 100-1.4.7.7 0 000 1.4z"
  })));
}
export default __webpack_public_path__ + "static/media/questionMarkRoundedFilled.49a2d8c8.svg";
export { SvgQuestionMarkRoundedFilled as ReactComponent };